var _rect, _path, _g, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 185,
    viewBox: "0 0 221 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 75,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_4516_51319)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 44.3048C105.039 42.8015 110.247 42.7643 115.14 44.1978L201.676 69.5467C207.399 71.2232 207.437 79.3173 201.729 81.0469L115.378 107.214C110.337 108.742 104.95 108.702 99.9323 107.101L18.214 81.0202C12.618 79.2343 12.6564 71.3026 18.2695 69.5709L100.166 44.3048Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4516_51319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137 75.5627C137 76.5466 120.044 75.5627 108.694 75.5627C97.3439 75.5627 80 74.7652 80 73.7814C80 72.7975 89.201 72 100.551 72C111.901 72 137 74.5789 137 75.5627Z",
    fill: "#7294FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.25 17.5H81.75C76.9171 17.5 73 21.4171 73 26.25V46.6667C73 51.4996 76.9171 55.4167 81.75 55.4167H134.25C139.083 55.4167 143 51.4996 143 46.6667V26.25C143 21.4171 139.083 17.5 134.25 17.5Z",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.833 35V32.0834C113.833 30.4734 112.527 29.1667 110.917 29.1667H105.083C103.473 29.1667 102.167 30.4734 102.167 32.0834V35C100.557 35 99.25 36.3067 99.25 37.9167V40.8334C99.25 42.4434 100.557 43.75 102.167 43.75H113.833C115.443 43.75 116.75 42.4434 116.75 40.8334V37.9167C116.75 36.3067 115.443 35 113.833 35Z",
    fill: "url(#paint1_linear_4516_51319)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4166 35V32.0834C93.4166 30.4734 92.11 29.1667 90.5 29.1667H84.6666C83.0566 29.1667 81.75 30.4734 81.75 32.0834V35C80.14 35 78.8333 36.3067 78.8333 37.9167V40.8334C78.8333 42.4434 80.14 43.75 81.75 43.75H93.4166C95.0266 43.75 96.3333 42.4434 96.3333 40.8334V37.9167C96.3333 36.3067 95.0266 35 93.4166 35Z",
    fill: "url(#paint2_linear_4516_51319)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.25 35V32.0834C134.25 30.4734 132.943 29.1667 131.333 29.1667H125.5C123.89 29.1667 122.583 30.4734 122.583 32.0834V35C120.973 35 119.667 36.3067 119.667 37.9167V40.8334C119.667 42.4434 120.973 43.75 122.583 43.75H134.25C135.86 43.75 137.167 42.4434 137.167 40.8334V37.9167C137.167 36.3067 135.86 35 134.25 35Z",
    fill: "url(#paint3_linear_4516_51319)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4516_51319",
    x: 66,
    y: 58,
    width: 85,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_4516_51319"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4516_51319",
    x1: 206,
    y1: 130,
    x2: 14,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4516_51319",
    x1: 108,
    y1: 29.1667,
    x2: 108,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B76F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4516_51319",
    x1: 87.5833,
    y1: 29.1667,
    x2: 87.5833,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B76F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4516_51319",
    x1: 128.417,
    y1: 29.1667,
    x2: 128.417,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B76F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.5c1c801f9bb479d22e18f43859cffaea.svg";
export { ForwardRef as ReactComponent };